import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/auth';

function PrivateRoute({ children }) {
  var { isAuthenticated } = useAuth();
  var location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/signup" state={{ referer: location }} replace />;
  }

  return children;
}

export default PrivateRoute;
